export * from './dashboard/machine-managed-dashboard-template';
export * from './delete/machine-managed-delete-template';
export * from './managed-project-wizard-new-template';
export * from './overview/machine-managed-overview-template';
export * from './overview-list/machine-managed-overview-list-template';
export * from './project-new/machine-managed-project-new-template';
export * from './setup/machine-managed-setup-template';
